<template>
    <div>
        <v-col cols="12">
            <h2>{{ t('acl::page.title.acl_entity_field') }}</h2>
        </v-col>

        <v-col cols="12">
            <div class="form-wrapper">
                <v-form ref="form" v-model="isFormValid">
                    <div>
                        <v-row>
                            <v-col cols="12" lg="6" class="py-0">
                                <b-input
                                    v-model="field.tag"
                                    field="acl::acl_entity_field.tag"
                                    :error-messages="errorMessages.tag"
                                    required
                                ></b-input>
                            </v-col>

                            <v-col cols="12" lg="6" class="py-0">
                                <b-select
                                    v-model="field.type"
                                    field="acl::acl_entity_field.type"
                                    required
                                    :select-items="filterTypes"
                                    item-text="label"
                                    item-value="value"
                                    :force-readonly="!!id"
                                    :force-disabled="!!id"
                                >
                                </b-select>
                            </v-col>

                            <v-col cols="12" lg="6" class="py-0">
                                <b-input
                                    v-model="field.name"
                                    field="acl::acl_entity_field.name"
                                    :error-messages="errorMessages.name"
                                    required
                                >
                                </b-input>
                            </v-col>

                            <v-col cols="12" lg="6" class="py-0">
                                <b-switch
                                    field="acl::acl_entity_field.visible"
                                    :value.sync="field.visible"
                                    :force-readonly="!!id"
                                    :force-disabled="!!id"
                                >
                                </b-switch>
                            </v-col>

                            <v-col cols="12" lg="6" class="py-0">
                                <b-input
                                    v-model="field.entity_class"
                                    field="acl::acl_entity_field.entity_class"
                                    required
                                    :force-readonly="!!id"
                                    :force-disabled="!!id"
                                    :error-messages="errorMessages.entity_class"
                                >
                                </b-input>
                            </v-col>

                            <v-col cols="12" lg="6" class="py-0">
                                <b-switch
                                    field="acl::acl_entity_field.audit_disabled"
                                    :value.sync="field.audit_disabled"
                                    :force-readonly="!!id"
                                    :force-disabled="!!id"
                                >
                                </b-switch>
                            </v-col>

                            <v-col cols="12" lg="6" class="py-0">
                                <b-input
                                    v-model="field.entity_field_name"
                                    field="acl::acl_entity_field.entity_field_name"
                                    required
                                    :force-readonly="!!id"
                                    :force-disabled="!!id"
                                >
                                </b-input>
                            </v-col>

                            <v-col cols="12" lg="6" class="py-0">
                                <b-switch
                                    field="acl::acl_entity_field.system"
                                    :value.sync="field.system"
                                    :force-readonly="!!id"
                                    :force-disabled="!!id"
                                >
                                </b-switch>
                            </v-col>

                            <v-col cols="12" lg="6" class="py-0">
                                <b-input
                                    v-model="field.db_table_name"
                                    field="acl::acl_entity_field.db_table_name"
                                    required
                                    :force-readonly="!!id"
                                    :force-disabled="!!id"
                                    :error-messages="errorMessages.db_table_name"
                                >
                                </b-input>
                            </v-col>

                            <v-col cols="12" lg="6" class="py-0">
                                <b-switch
                                    field="acl::acl_entity_field.hidden"
                                    :value.sync="field.hidden"
                                    :force-readonly="!!id"
                                    :force-disabled="!!id"
                                >
                                </b-switch>
                            </v-col>

                            <v-col cols="12" lg="6" class="py-0">
                                <b-input
                                    v-model="field.db_field_name"
                                    field="acl::acl_entity_field.db_table_name"
                                    required
                                    :force-readonly="!!id"
                                    :force-disabled="!!id"
                                    :error-messages="errorMessages.db_field_name"
                                >
                                </b-input>
                            </v-col>
                        </v-row>
                    </div>
                    <b-form-actions
                        :id="id"
                        :back-route="$root.route('acl.entity-fields.index')"
                        :has-save-button="can('api.v1.acl.entity-fields.update')"
                        :has-discard-button="can('api.v1.acl.entity-fields.update')"
                        @discard="reset"
                        @save="save"
                    ></b-form-actions>
                </v-form>
            </div>
        </v-col>
    </div>
</template>

<script>
let formSubmitMixin = require(process.env.MIX_APP_ROOT +
    '/bgo/bgo-components/resources/js/mixins/FormSubmit.js').default;

export default {
    mixins: [formSubmitMixin],
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            saveLoading: false,
            isFormValid: false,
            fieldOriginal: null,
            filterTypes: [
                { label: t('acl::field_type.field'), value: 'field' },
                { label: t('acl::field_type.association'), value: 'association' },
            ],
            errorMessages: {
                name: [],
                tag: [],
                entity_name: [],
                entity_field_name: [],
                db_table_name: [],
                db_field_name: [],
                field_type: [],
                type: [],
                system: [],
                hidden: [],
                visible: [],
                audit_disabled: [],
            },
            field: {
                name: null,
                tag: null,
                entity_name: null,
                entity_field_name: null,
                db_table_name: null,
                db_field_name: null,
                field_type: null,
                type: null,
                system: false,
                hidden: false,
                visible: true,
                audit_disabled: false,
            },
        };
    },
    created() {
        this.loadField();
    },
    methods: {
        loadField() {
            if (_.isEmpty(this.id)) {
                this.loading = false;
                return;
            }

            axios
                .get(route('api.v1.acl.entity-fields.show', { entity_field: this.id }))
                .then((response) => {
                    this.field = response.data.data;
                    this.fieldOriginal = _.clone(this.field);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        reset() {
            this.field = _.clone(this.fieldOriginal);
        },
        save() {
            this.submit(
                route('api.v1.acl.entity-fields.update', {
                    entity_field: this.field.id,
                }),
                this.field,
                'put',
                () => {
                    this.$root.notify('success', t('default::notification.saved'));
                    this.$root.goTo(route('acl.entity-fields.index'));
                }
            );
        },
    },
};
</script>
